import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import { translations } from '../translations';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const {
    language,
    setLanguage
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  const t = translations.nav[language];
  const navLinks = [{
    name: t.home,
    path: '/'
  }, {
    name: t.sessions,
    path: '/services'
  }, {
    name: t.retreats,
    path: '/retreats'
  }, {
    name: t.contact,
    path: '/contact'
  }];
  const LanguageSelector = ({
    mobile = false
  }) => <div className={`flex items-center space-x-2 font-cinzel text-xs uppercase tracking-widest ${mobile ? 'mt-8 text-lg' : ''}`} data-id="element-19" data-mp="mgduwv0mh8ry">
      <button onClick={() => setLanguage('en')} className={`transition-colors ${language === 'en' ? 'text-rose' : 'text-cream/40 hover:text-cream/80'}`} data-id="element-20" data-mp="rgia8hpsnxgl">
        EN
      </button>
      <span className="text-cream/20" data-id="element-21" data-mp="10fn7lkpmdkr6">|</span>
      <button onClick={() => setLanguage('fr')} className={`transition-colors ${language === 'fr' ? 'text-rose' : 'text-cream/40 hover:text-cream/80'}`} data-id="element-22" data-mp="10elt169eag4p">
        FR
      </button>
    </div>;
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-dark/80 backdrop-blur-md py-4 border-b-[0.5px] border-white/10' : 'bg-transparent py-6'}`} data-id="element-23" data-mp="1a56r8sl5pin3">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-24" data-mp="1k4e4zgvszfaq">
          <Link to="/" className="text-gold font-cinzel text-2xl tracking-widest hover:opacity-80 transition-opacity" data-id="element-25" data-mp="ugidw2j29y0j">
            JC
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-10" data-id="element-26" data-mp="146v70j4xyzia">
            <nav className="flex space-x-10" data-id="element-27" data-mp="zfd61v2x4yxb">
              {navLinks.map(link => {
              const isActive = location.pathname === link.path;
              return <Link key={link.name} to={link.path} className="relative group text-xs font-inter uppercase tracking-widest text-cream/90 hover:text-gold transition-colors" data-id="element-28" data-mp="1d4ngh6nzfcxr">
                    {link.name}
                    <span className={`absolute -bottom-2 left-0 h-[1px] bg-gold transition-all duration-300 ${isActive ? 'w-full' : 'w-0 group-hover:w-full'}`} data-id="element-29" data-mp="1n2lc4f868c0e" />
                  </Link>;
            })}
            </nav>
            <div className="h-4 w-[1px] bg-white/10 mx-4" data-id="element-30" data-mp="3jwxz9w3xfspi"></div>
            <LanguageSelector data-id="element-31" data-mp="3jyiulny2ffof" />
          </div>

          {/* Mobile Menu Toggle & Lang Selector */}
          <div className="md:hidden flex items-center space-x-6" data-id="element-32" data-mp="1zffa59wdrsbz">
            <LanguageSelector data-id="element-33" data-mp="24e9uig9zxoy7" />
            <button className="text-cream p-2" onClick={() => setIsMobileMenuOpen(true)} data-id="element-34" data-mp="24d73m8cobmia">
              <Menu size={24} data-id="element-35" data-mp="1pokp28uveys4" />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-36" data-mp="1ulualdf52qao">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        x: '100%'
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: '100%'
      }} transition={{
        type: 'tween',
        duration: 0.3
      }} className="fixed inset-0 z-[60] bg-dark flex flex-col" data-id="element-37" data-mp="1go5z2w6yovia">
            <div className="flex justify-between items-center p-6 border-b-[0.5px] border-white/10" data-id="element-38" data-mp="1bq47fmvgznv7">
              <span className="text-gold font-cinzel text-2xl tracking-widest" data-id="element-39" data-mp="315kft01kl5k1">
                JC
              </span>
              <button onClick={() => setIsMobileMenuOpen(false)} className="text-cream p-2" data-id="element-40" data-mp="362kl38qli4a3">
                <X size={24} data-id="element-41" data-mp="160bbhm7ko3ro" />
              </button>
            </div>

            <div className="flex-1 flex flex-col justify-center items-center space-y-8" data-id="element-42" data-mp="1132tpmqc61qy">
              {navLinks.map(link => {
            const isActive = location.pathname === link.path;
            return <Link key={link.name} to={link.path} className={`text-xl font-inter uppercase tracking-widest ${isActive ? 'text-gold' : 'text-cream'}`} data-id="element-43" data-mp="s09zbalux9ww">
                    {link.name}
                  </Link>;
          })}
              <LanguageSelector mobile={true} data-id="element-44" data-mp="i9yxbtlqhasn" />
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}